import { EmptyState, PageHeader, Panel } from "../components/ui";
import { useT } from "../i18n";

export function ComingSoon({ feature }: { feature: string }) {
  const t = useT();
  return (
    <>
      <PageHeader title={feature} />
      <Panel>
        <EmptyState icon="clock" title={t("soon.title")} action={<a href="#/" className="button button-secondary">{t("common.backToOverview")}</a>}>
          {t("soon.body", { feature })}
        </EmptyState>
      </Panel>
    </>
  );
}

export function NotFound() {
  const t = useT();
  return (
    <Panel>
      <EmptyState icon="info" title={t("soon.unknownTitle")} action={<a href="#/" className="button button-secondary">{t("common.backToOverview")}</a>}>
        {t("soon.unknownBody")}
      </EmptyState>
    </Panel>
  );
}

export function AccessDenied() {
  const t = useT();
  return (
    <Panel>
      <EmptyState icon="lock" title={t("access.title")} action={<a href="#/" className="button button-secondary">{t("common.backToOverview")}</a>}>
        {t("access.body")}
      </EmptyState>
    </Panel>
  );
}
